import type { Reducer } from 'redux';
import { Actions } from '@/redux/campaign/actions';
import type { CampaignState, CampaignAction } from '@/redux/campaign/types';

export const initialState = {
  translations: {},
  gameIndex: 0
} as CampaignState;

export default ((state = initialState, action: CampaignAction) => {
  switch (action.type) {
    case Actions.SetCampaignData:
      return { ...state, ...action.data };

    case Actions.SetCampaignDataFail:
      return { ...state, error: action.error };

    case Actions.SetCampaignGameIndex:
      return { ...state, ...{ gameIndex: action.index } };

    case Actions.SetCampaignGameIndexFail:
      return { ...state, error: action.error };

    case Actions.SetCampaignServerTime:
      return { ...state, ...{ serverTime: action.time } };

    case Actions.SetCampaignServerTimeFail:
      return { ...state, error: action.error };

    case Actions.SetCampaignCurrentTime:
      return { ...state, ...{ currentTime: action.time } };

    case Actions.SetCampaignCurrentTimeFail:
      return { ...state, error: action.error };

    default:
      return state;
  }
}) as Reducer<CampaignState, CampaignAction>;
